import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_AUTH_API_URL}/NguoiDung`;

export default {    
    // getAllPaging: async (params) => {
    //     const requestOptions = {
    //         method: 'POST',
    //         headers: await header.authHeaderWithToken(),
    //         body: JSON.stringify({ 
    //             "currentPage": params.currentPage,
    //             "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
    //             "sortBy": (params.sortBy)? params.sortBy: "0",
    //             "orderDesc": params.sortDesc,
    //             "searchkey": (params.searchKey)? params.searchKey: ""
    //         })
    //     };
    
    //     let rs = await fetch(`${mainUrl}/GetAllPaging`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // getById: async (id) => {
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: header.authHeaderWithToken()
    //     };
    //     let rs = await fetch(`${mainUrl}/GetById?id=${id}`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // getByUsername: async (username) => {
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: header.authHeaderWithToken()
    //     };
    //     let rs = await fetch(`${mainUrl}/GetByUsername?username=${username}`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // isExistUsername: async (username) => {
    //     const requestOptions = {
    //         method: 'POST',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify({ username: username })
    //     };
    //     let rs = await await fetch(`${mainUrl}/CheckExistsUserName`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // create: async (user) => {
    //     var requestOptions = {
    //         method: 'POST',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify({
    //             "fullname": user.fullname,
    //             "username": user.username,
    //             "password": user.password,
    //             "email": user.email,
    //             "phoneNumber": user.phoneNumber,
    //             "roleStr": user.roles.join(',')
    //         }),
    //     };
    
    //     let rs = await fetch(`${mainUrl}/Create`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // update: async (user) => {
    //     const requestOptions = {
    //         method: 'PUT',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify({
    //             "id": user.id,
    //             "fullname": user.fullname,
    //             "email": user.email,
    //             "phoneNumber": user.phoneNumber,
    //             "roleStr": user.roles.join(','),
    //         })
    //     };
    
    //     let rs = await fetch(`${mainUrl}/Update`, requestOptions);
    //     return await common.handleResponse(rs);
    // },

    getProfile: async (userId) => {
        const requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "actionCode": 21,
                "userId": userId
            })
        };
    
        let rs = await fetch(`${mainUrl}/QueryData`, requestOptions);
        return await common.handleResponse(rs);
    },

    updateProfile: async (user) => {
        const requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "hoTen": user.hoTen,
                "gioiTinh": user.gioiTinh,
                "email": user.email,
                "sdt": user.sdt,
                "donViId": user.donViId,
                "chucDanhId": user.chucDanhId,
                "quanHuyenId": user.quanHuyenId,
                "phuongXaId": user.phuongXaId,
                "khomApId": user.khomApId,
                "toDanPhoId": user.toDanPhoId,
                "duongPhoId": user.duongPhoId,
                "soNha": user.soNha,
                "diaChi": user.diaChi,
            })
        };
    
        let rs = await fetch(`${mainUrl}/UpdatePersonalAccount`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    // delete: async (id) => {
    //     const requestOptions = {
    //         method: 'DELETE',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify({ id })
    //     };
    
    //     let rs = await fetch(`${mainUrl}/Delete`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    // deleteMany: async (ids) => {
    //     const requestOptions = {
    //         method: 'DELETE',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify(ids)
    //     };
    
    //     let rs = await fetch(`${mainUrl}/DeleteMany`, requestOptions);
    //     return await common.handleResponse(rs);
    // },
    
    changePass: async (password, passwordNew, passwordNewConfirmed) => {
        const requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({ password, passwordNew, passwordNewConfirmed })
        };
    
        let rs = await fetch(`${mainUrl}/ChangePassword`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    // resetPass: async (userId, newPass) => {
    //     const requestOptions = {
    //         method: 'PUT',
    //         headers: header.authHeaderWithToken(),
    //         body: JSON.stringify( { id: userId, password: newPass } )
    //     };
    
    //     let rs = await fetch(`${mainUrl}/ResetPass`, requestOptions);
    //     return await common.handleResponse(rs);
    // }
}